<template>
  <div class="selection-area">
    <div v-for="(pkg, index) in packages" :key="index">
      <div @click="select(pkg)" class="selection-item" :class="{ selected: pkg.id === value }">
        <div class="package">
          <div class="package-header">
            <div class="d-flex align-items-baseline">
              <div class="price">{{ getPrice(pkg) }}</div>
              <div>/ mo</div>
            </div>
            <div class="name">{{ pkg.name }}</div>
          </div>
          <div class="attributes-section">
            <ul>
              <li>{{ getBandwidth(pkg) }}</li>
              <li>{{ getDiskSpace(pkg) }}</li>
            </ul>
          </div>
          <div class="d-flex justify-content-center">
            <Btn :variant="pkg.id === value ? 'primary' : 'primaryOutline'">
              {{ $t("global.select") }}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import { fromGBFormat } from "leatherman-js/utils/formatters/size";
import { moneyFormat } from "leatherman-js/utils/formatters/money";

export default {
  name: "FormDevSitePackageSelect",
  props: {
    packages: {
      type: Array,
      required: true,
    },
    planTerm: {
      type: Number,
      required: true,
    },
    value: Number,
  },
  components: {
    Btn,
  },
  setup(props, { emit, root }) {
    const getBandwidth = (pkg) =>
      root.$t("global.package-bandwidth", { GB: fromGBFormat(pkg.bandwidth) });
    const getDiskSpace = (pkg) =>
      root.$t("global.package-disk-space", { GB: fromGBFormat(pkg.diskSpace) });
    const getName = (pkg) => pkg.name;
    const getPrice = (pkg) => moneyFormat(pkg.pricing[props.planTerm.toString()]);
    const select = (pack) => emit("input", pack.id);

    return {
      getBandwidth,
      getName,
      getDiskSpace,
      getPrice,
      select,
    };
  },
};
</script>

<style lang="scss"></style>
